import { FC, MouseEvent, useCallback, useContext, useRef, useState } from 'react';

import { UserTypeContext } from '@/shared/lib/UserTypeContext/UserTypeContext';

import ShoppingCartButton from './ShoppingCartButton';
import ShoppingCartPopover from './ShoppingCartPopover';

const ShoppingCart: FC<{ isExpanded: boolean }> = ({ isExpanded }) => {
  const userType = useContext(UserTypeContext);
  const buttonRef = useRef<HTMLButtonElement>(null);

  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  if (!userType || !['advertiser'].includes(userType)) {
    return null;
  }

  return (
    <>
      <ShoppingCartButton ref={buttonRef} handleClick={handleClick} isExpanded={isExpanded} />

      <ShoppingCartPopover anchorEl={anchorEl} handleClose={handleClose} />
    </>
  );
};

export default ShoppingCart;
